import React from "react";

// Material UI
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Stack,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Styles
import { textStyles, commonStyles } from "Common/Styles";

// Common
import { messageVariables, findPreviewDataValue } from "./MessageValues";

export const MoreInfoAccordion = ({ clinic }) => {
  return (
    <Container disableGutters sx={commonStyles.paperContainer}>
      <Accordion
        defaultExpanded
        sx={{ background: "transparent", boxShadow: "none" }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          id="more-info-header"
          aria-controls="more-info-content"
        >
          <Typography sx={textStyles.title}>Notification Settings</Typography>
        </AccordionSummary>
        <AccordionDetails
          id="more-info-content"
          aria-labelledby="more-info-header"
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 1,
            px: 2,
          }}
        >
          <Stack width="50%" gap={2}>
            <Typography sx={textStyles.infoText}>
              These messages will be sent to the cell phone number specified by
              the patient.
            </Typography>
            <Typography sx={textStyles.infoText}>
              The fields below use mocked patient information to display a
              preview of the message and indicate the remaining character count.
            </Typography>
            <Typography sx={textStyles.infoText}>
              These variables are placeholders and will not be counted towards
              the character limit.
            </Typography>
          </Stack>
          <TableContainer
            component={Paper}
            sx={{
              display: "flex",
              justifyContent: "center",
              boxShadow: "none",
            }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={textStyles.subtitle}>Field Name</TableCell>
                  <TableCell sx={textStyles.subtitle}>English</TableCell>
                  <TableCell sx={textStyles.subtitle}>French</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {messageVariables.map((v) => {
                  return (
                    <TableRow key={v.name}>
                      <TableCell sx={textStyles.subtitle2}>{v.label}</TableCell>
                      <TableCell sx={textStyles.infoText}>
                        {findPreviewDataValue(v.name, "en", clinic)}
                      </TableCell>
                      <TableCell sx={textStyles.infoText}>
                        {findPreviewDataValue(v.name, "fr", clinic)}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
    </Container>
  );
};
